export const profile = {
  name: 'Habeeb Sait',
  roles: ['App Developer', 'AI Enthusiast', 'Robotics Builder', 'Problem Solver'],
  subtitle:
    'Creating innovative solutions through AI, robotics, and mobile development. Passionate about building technology that makes a difference.',
  // Drop a headshot at src/me.jpg and set this to true to use it.
  photo: null, // e.g. require('../me.jpg')
  initials: 'HS',
  bio: [
    "I'm a builder at heart — I founded and shipped Wovvii, a full-stack food delivery platform, and I've taken ideas from a Raspberry Pi on my desk all the way to apps in the store.",
    'My work sits at the intersection of mobile, AI, and robotics: Flutter apps, FastAPI backends, LLM-powered systems, and hardware that listens and moves. I care about products that feel fast, look sharp, and actually help people.',
  ],
  stats: [
    { value: 'Founder', label: 'of Wovvii' },
    { value: '5+', label: 'products shipped' },
    { value: 'AI · Robotics', label: '· Mobile' },
  ],
  socials: {
    linkedin: 'https://www.linkedin.com/in/habeeb-sait-20578b257/',
    github: 'https://github.com/habeebsait',
    email: 'habeebdoesbusiness@gmail.com',
    resume: '/HabeebResume.pdf',
  },
};
